export default __webpack_public_path__ + "static/media/WFSCCoachID-RussellDear.bf56e0d2.png";